@if (allowanceEntity$ | async) {
  <div>
    <snelstart-ui-alert>
      Toeslagen worden per maand berekend, vandaar dat de gegevens van de partner per maand worden uitgevraagd.
      <br/>Let er wel op dat je bij inkomen en vermogen de bedragen voor geheel {{ this.year }} invult.
    </snelstart-ui-alert>
  </div>

  <form [formGroup]="formGroup">
    @if (inkomensGegevensList.length > 0) {
      <div formArrayName="inkomensgegevens">
        @for (item of inkomensGegevensList.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                @if (i === 0) {
                  <div class="pt-4" style="width: 150px">
                    {{ this.getLabel(i + 1) }}
                  </div>
                } @else {
                  <div class="pt-1" style="width: 150px">
                    {{ this.getLabel(i + 1) }}
                  </div>
                }
              </div>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Toeslagpartner?' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-150"
                                                formControlName="toeslagPartner"
                                                id="partner-{{i}}"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-bsn-form-control [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                             class="custom-input-150"
                                             formControlName="bsnPartner"
                                             id="bsn-{{i}}"
              >
              </snelstart-ui-bsn-form-control>
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Geboortedatum' : ''"
                                              class="custom-input-150"
                                              formControlName="geboortedatumPartner"
                                              id="geboortedatumPartner-{{i}}"
                                              placeholder="dd-mm-jjjj"
              >
              </snelstart-ui-date-form-control>
              <snelstart-ui-number-form-control [label]="i === 0 ? 'Inkomen gehele jaar' : ''"
                                                [showAllDecimals]="false" align="right"
                                                class="custom-input-150"
                                                formControlName="toetsinkomenPartner"
                                                id="toetsinkomenPartner-{{i}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [label]="i === 0 ? 'Vermogen gehele jaar' : ''"
                                                [showAllDecimals]="false" align="right"
                                                class="custom-input-150"
                                                formControlName="toetsvermogenPartner"
                                                id="toetsvermogenPartner-{{i}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Zorgverzekering Ned.?' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-150"
                                                formControlName="partnerHeeftZorgverzekering"
                                                id="partnerHeeftZorgverzekering-{{i}}"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-button (click)="copyFromPrevious(i)"
                                   [class]="i===0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   [disabled]="i===0"
                                   icon="copy"
                                   style="padding-top: 4px"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
}
